import PropTypes from 'prop-types';

import {IDType} from 'utils/prop-types';

export const ModuleShape = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
};

export const BlockShape = {
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
};

export const LessonShape = {
    id: IDType.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    module: PropTypes.shape(ModuleShape),
    language: PropTypes.string.isRequired,
    is_important: PropTypes.bool.isRequired,
    is_public: PropTypes.bool.isRequired,
    blocks: PropTypes.arrayOf(PropTypes.shape(BlockShape)).isRequired,
    completionURL: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/shapes.js